import { AttributeGroup } from 'state/attributeGroup'
import { viewport } from 'state/viewport'
import { classList } from 'MK/DOM/fns/classList'

MK.events.on('attribute:groups:toggleRefinementMenu', (event = {}) => {
  event && event.preventDefault && event.preventDefault()

  let menu = document.getElementById('mk-mobile-filtermenu')
  let gladlyChat = document.getElementById('gladlyChat_container')

  if (viewport().format.active === 'mobile') {
    // Hide (toggle) gladlyChat bubble icon
    console.log('DEBUG (attribute:groups:toggleRefinementMenu) Toggling hide class on element with ID: gladlyChat_container', gladlyChat)
    gladlyChat && classList.toggle(gladlyChat, 'hide')

    let leftnav = MK.DOM.fns.getElementById('leftnav')
    console.log('DEBUG (attribute:groups:toggleRefinementMenu) Toggling open class on element with ID: leftnav', leftnav)
    leftnav && classList.toggle(leftnav, 'open')
  }

  if (menu) {
    // AttributeGroup.groups.forEach(group => group.toggle('collapsed', false))
    AttributeGroup.groups.forEach(group => MK.events.emit('attribute:group:toggle', {
      target: group,
      property: 'collapsed',
      value: false
    }))
    // If active viewport is mobile, toggle noScroll class.
    // Else, if desktop or tablet, remove entirely.
    viewport().format.active === 'mobile' ? classList.toggle(document.body, 'noScroll') : classList.remove(document.body, 'noScroll')
    classList.toggle(menu, 'visible')
  }

  return false
})
